import { render, staticRenderFns } from "./StaffTemplates.vue?vue&type=template&id=eaea7ae2&scoped=true"
import script from "./StaffTemplates.vue?vue&type=script&lang=js"
export * from "./StaffTemplates.vue?vue&type=script&lang=js"
import style0 from "./StaffTemplates.vue?vue&type=style&index=0&id=eaea7ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaea7ae2",
  null
  
)

export default component.exports